import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CastCrewModalContent {
    filmography?: any[];
    position?: string;
    title?: string;
    image?: string;
}

interface CastCrewModalState {
    isOpen: boolean;
    modalContent: CastCrewModalContent | null;
}

const initialState: CastCrewModalState = {
    isOpen: false,
    modalContent: null,
};

const castCrewModalSlice = createSlice({
    name: 'castCrewModal',
    initialState,
    reducers: {
        open(state, action: PayloadAction<CastCrewModalContent>) {
            state.isOpen = true;
            state.modalContent = action.payload;
        },
        close(state) {
            state.isOpen = false;
            state.modalContent = null;
        },
        updateContent(state, action: PayloadAction<CastCrewModalContent>) {
            state.modalContent = { ...state.modalContent, ...action.payload };
        },
    },
});

export const { open, close, updateContent } = castCrewModalSlice.actions;
export default castCrewModalSlice.reducer;
